<template>
  <div class="dnd-page">
    <div class="flex-grid-thirds">
      <div class="sml-col"/>
      <div class="col">
        <DndCampaignGenerator />
        <!-- <h1>Wait. What Is This??</h1>
        <p>In an effort to become even <i>more</i> of a nerd I decided I should spend some free time attempting to generate DND name, race and class combos using machine learning. Then as a bonus also generate a bio for that character.</p>
        <p>
          The names were generated using GPT2's publically available small parameter model with Max Woolf's <a href="https://github.com/minimaxir/gpt-2-simple" target="_blank">gpt2-simple</a>. 
          The model was finetuned on crowdsourced data collected by Janelle Shane at <a href="https://github.com/janelleshane/DnD-characters" target="_blank">AI Weirdness</a>. 
        </p>
        <p>Want to see a GAN generated map of where your DND Character might live or adventure?? Check out a WIP version of my map generator <router-link to="/dnd-map">here</router-link>.</p> -->
      </div>
      <div class="sml-col"></div>
    </div>
  </div>
</template>

<script>
  import DndCampaignGenerator from '../components/DndCampaignGenerator'
  export default {
    name: 'DndCampaignPage',
    components: {
      DndCampaignGenerator
    }
  }
</script>
<style scoped>
  .dnd-page {
    text-align: center;
    font-size: 16px;
  }

  h1 {
    font-size: 2em;
    color: black;
    font-family: 'Press Start 2P', cursive;
    padding-top: 2em;
  }

   .flex-grid {
  display: flex;
  }
  .col {
    flex: 1;
  }

  .flex-grid-thirds {
    display: flex;
    justify-content: space-between;
  }

  .flex-grid-thirds .col {
    width: 40%;
  }

  .flex-grid-thirds .sml-col {
    width: 10%;
    text-align: left;
  }
</style>
